<template>
  <custom-dialog
    color="error"
    ref="dialog"
    icon="priority_high"
    store-modal
    :title="generateMessage('requests.actions.rejection')"
  >
    <v-form v-model="valid" ref="form">
      <div class="d-flex mt-2">
        <v-select
          class="mx-2 test-select"
          style="max-width: 200px;"
          v-model="reject_code"
          item-text="name"
          item-value="code"
          :items="items"
          :placeholder="
            generateMessage('requests.actions.rejection_reason') + ' *'
          "
          :rules="[
            (v) =>
              !!v || generateMessage('requests.actions.no_rejection_reason'),
          ]"
          color="error"
          clearable
          outlined
          dense
        />
        <v-checkbox
          class="mx-2"
          v-model="customer_visibility"
          :label="generateMessage('requests.actions.engiedirect_visible')"
          color="error"
        />
      </div>
      <custom-text-area
        class="mx-2 test-textarea"
        color="error"
        v-model="reject_description"
        :maxCharacter="60"
        errorTooLongMsg="Maximum 60 caractères"
        :label="generateMessage('requests.actions.comment')"
      />
    </v-form>
    <template v-slot:actions>
      <div class="d-flex justify-end">
        <v-btn
          small
          color="error"
          :disabled="!valid"
          :loading="isLoading"
          @click="reject"
          class="mx-2 text-validate-btn"
        >
          {{ generateMessage('requests.actions.validate') }}
        </v-btn>
        <v-btn small class="mx-2" @click="cancel">
          {{ generateMessage('requests.actions.cancel') }}
        </v-btn>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import { mapGetters } from 'vuex';
import CustomDialog from '@/components/dialogs/CustomDialog';
import CustomTextArea from '@/components/CustomTextArea';
import rejectRequest from '@/services/api/internal/requestActions/rejection.api';
import { setDispActive } from '@/services/api/internal/requestActions/selfAssign.api';
import { catchCRUDError } from '@/business/apiTreatment/response/errorTreatment';

export default {
  name: 'RejectionDialog',
  components: {
    CustomTextArea,
    CustomDialog,
  },
  props: {
    requestId: {
      type: Number,
      required: true,
    },
    isPaused: {
      type: Boolean,
      required: false,
      default: false,
    },
    isAssigned: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    generateMessage,
    rejectRequest,
    setDispActive,
    cancel() {
      this.$refs.dialog.handleCloseClick();
    },
    reject() {
      this.isLoading = true;
      this.setDispActive({
        requestId: this.requestId,
        groupId: this.groupId,
        isPaused: this.isPaused,
        isAssigned: this.isAssigned,
      })
        .then(async () => {
          await this.rejectRequest(this.requestId, {
            reject_code: this.reject_code,
            customer_visibility: this.customer_visibility ? 'O' : 'N',
            reject_description: this.reject_description,
          })
            .then(() => {
              this.cancel();
              this.$store.dispatch('requests/refreshItems');
              this.$store.dispatch('requests/removeCurrent', this.requestId);
              this.$store.dispatch('boilerplate/setModalClosed');
            })
            .catch((err) => {
              this.$store.dispatch(
                'snackbar/setSnackbarOpen',
                catchCRUDError('REJECT', err)
              );
            });
        })
        .catch((err) => {
          this.$store.dispatch(
            'snackbar/setSnackbarOpen',
            catchCRUDError('ADD', err)
          );
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    initForm() {
      this.reject_code = null;
      this.customer_visibility = true;
      this.reject_description = '';
      this.valid = false;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
  },
  computed: {
    ...mapGetters({
      items: 'requests/rejectionTypes/items',
    }),
  },
  watch: {
    requestId: {
      handler() {
        this.initForm();
      },
      immediate: true,
    },
  },
  data() {
    return {
      reject_code: null,
      customer_visibility: false,
      reject_description: '',
      valid: false,
      isLoading: false,
    };
  },
};
</script>
